import React from "react";
import {useState,useEffect} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Box} from "@mui/system";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import {confirmDialog} from "primereact/confirmdialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dropdown} from "primereact/dropdown";
import Message from "../Helpers/Message.js";
import {fetch_url_post,fetch_download} from "../../Sources/js/app.js";

let oper="";

let currentDate=new Date();
let currentYear=currentDate.getFullYear();
let yearsList=[];

for(let i=-2;i<2;i++) {
	let cYear={
		label: currentYear+i,
		value: currentYear+i
	}
	yearsList.push(cYear);
} 

let defaultInputValues={
	filter_products: "",
	filter_product_type: "",
	filter_years: currentYear,
};

let defaultDataValues={
	productsList: [],
	productsTypesList: [],
	productsDetailsList: [],
};

let defaultDialogValues={
	openDetails: false,
	titleDetails: "",
};

let currentProduct={};

const ProductsSummaryYearly = (props) => {

	var timerId=null;

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [dataValues, setDataValues] = useState(defaultDataValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [blockScreen, setBlockScreen] = useState(false);
	const [productsList, setProductsList] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();

	const handleChange = evt => {
		const {name, value} = evt.target;
		if(name==="filter_products") {
			setProductsList(dataValues.productsList.filter((product)=>((product.name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		if(name==="filter_product_type") {
			setProductsList(dataValues.productsList.filter((product)=>((product.product_type_id===value)||(value==="")||(!value))));
		}
		if(name==="filter_years") {
			setProductsList([]);
		}
		setInputValues({...inputValues,[name]:value});
	}

	const handleButton = (evt,what,elementData) => {
		if(what==="report") {
			oper="get";
			let url="getProductsSummaryYearly";
			url+="?session_id="+props.session.sessId;
			let data={
				year: inputValues.filter_years,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);			
		}
		if(what==="details") {
			currentProduct=elementData;
			oper="get_details";
			let url="getProductsSummaryDetailsYearly";
			url+="?session_id="+props.session.sessId;
			let data={
				year: inputValues.filter_years,
				product_id: elementData.product_id,
				product_mu_id: elementData.product_mu_id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);			
		}
		if(what==="export") {
			let url="getXLSProductsSummaryYearly";
			oper="download";
			url+="?session_id="+props.session.sessId;
			let type_name=(inputValues.filter_product_type?dataValues.productsTypesList.filter((type)=>type.id===inputValues.filter_product_type)[0].name:"");
			let data={
				year: inputValues.filter_years,
				product_type_id: inputValues.filter_product_type,
				type_name: type_name,
			};
			fetch_download(url,data,"centralizator_anual_produse",success_handler);
			setBlockScreen(true);
			setMessageText("Se genereaza raportul...");
		}
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
			setMessageText("");
		}
		if(result.ok===0) {
			setMessageText("Eroare: "+result.error);
			return false;
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if(oper==="get") {
			setDataValues({...dataValues,productsList:(result.productsList?result.productsList:[]),
										productsTypesList:(result.productsTypesList?result.productsTypesList:[])
			});
			setProductsList(result.productsList?result.productsList.filter((product)=>((product.product_name.toLowerCase().indexOf(inputValues.filter_products.toLowerCase())>-1))||(inputValues.filter_products===""))
																	.filter((product)=>((product.product_type_id===inputValues.filter_product_type)||(inputValues.filter_product_type==="")||(!inputValues.filter_product_type)))
			:[]);
            if(!dataOk) {
                setDataOk(true);
            }
			oper="";
		}
		if(oper==="get_details") {
			setDataValues({...dataValues,productsDetailsList:(result.productsDetailsList?result.productsDetailsList:[])});
			setDialogValues({...dialogValues,openDetails: true,titleDetails: "Detalii produs "+currentProduct.product_name+" ["+currentProduct.product_mu+"]"});			
			oper="";
		}
		if(oper==="download") {
			setMessageText(null);
			setBlockScreen(false);
			oper="";
		}
	}

	const fail_handler = () => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
		}
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	const wait_handler = () => {
		setBlockScreen(true);
		setMessageText("Operatiunea este in curs...");
	}

	useEffect(() => {
		if(props.session.sessId) {
			oper="get";
			let url="getProductsSummaryYearly";
			url+="?session_id="+props.session.sessId;
			let data={
				year: inputValues.filter_years,
			};
			fetch_url_post(url,data,success_handler,fail_handler);
		}else{
			navigate("/login");
		}
	},[props.session.sessId]);

	const detailsDialog = () => {
		return(
			<Dialog header={dialogValues.titleDetails} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openDetails:false})} className="responsive-dialog-med">
				<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
					<DataTable
						id="products_summary"
						value={dataValues.productsDetailsList}
						scrollable
						scrollHeight="60vh"
						style={{"minHeight":"63vh","width":"98%"}}
						scrollDirection="both"
						stripedRows
						resizableColumns
						columnResizeMode="fit"
						emptyMessage="Nu exista inregistrari"
					>
						<Column field="center_name" header="Nume centru" style={{"flexGrow":"1","flexBasis":"300px"}} sortable></Column>
						<Column field="product_name" header="Produs" style={{"flexGrow":"1","flexBasis":"300px"}} sortable></Column>
						<Column field="product_mu" header="U.M." style={{"flexGrow":"0","flexBasis":"90px"}} sortable></Column>								
						<Column field="quantity" header="Cantitate" style={{"flexGrow":"0","flexBasis":"90px"}} sortable></Column>
					</DataTable>
				</Box>
			</Dialog>
		);
	}

	const tableColTemplate = (row_data,column) => {
		if(column.field==="product_type") {
			return(
				<div className="flex align-items-center gap-2">
					<span className="font-bold">{row_data.product_type}</span>
				</div>
			);
		}		
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Detalii" icon="pi pi-list" tooltip="Editeaza furnizor" className="p-button-sm p-button-raised" style={{}} onClick={(evt) => handleButton(evt,"details",row_data)}/>
				</span>
			);
		}
	}

	const confirm = (evt,what,elementData) => {
		if(what==="delete") {
			confirmDialog({
				message: "Sigur doriti stergerea?",
				header: "Confirmare stergere",
				icon: "pi pi-exclamation-triangle",
				accept: () => handleButton(evt,what,elementData),
				reject: () => null,
			});
		}
	}

	if(dataOk) {
		return(
			<BlockUI blocked={blockScreen} fullScreen>
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={4} md={10} lg={10} xl={10} className="field padding-med">
							<InputText name="filter_products" id="filter_products" style={{"width":"35%","marginRight":"3px"}} value={inputValues.filter_products} placeholder="Cauta produs..." onChange={(evt) => handleChange(evt)}/>							
							<Dropdown name="filter_product_type" id="filter_product_type" style={{"width":"33%","marginRight":"3px"}} filter options={dataValues.productsTypesList} placeholder="Filtrare categorie..." showClear optionLabel="name" optionValue="id" value={inputValues.filter_product_type} onChange={(evt) => handleChange(evt)}/>
							<Dropdown name="filter_years" id="filter_years" style={{"width":"10%","marginRight":"12px"}} options={yearsList} value={inputValues.filter_years} onChange={(evt) => handleChange(evt)}/>	
							<Button label="Genereaza" icon="pi pi-check-circle" className="p-button-sm p-button-primary p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => {handleButton(evt,"report")}}/>
							<Button label="Export" icon="pi pi-file-excel" className="p-button-sm p-button-primary p-button-raised" style={{}} disabled={(productsList.length>0?false:true)} onClick={(evt) => {handleButton(evt,"export")}}/>
						</Grid>								
						<Grid item xs={12} sm={8} md={2} lg={2} xl={2} className="field padding-med text-left">
							<h6 style={{"marginTop":"9px","color":"#000000"}}>{productsList.length} {(((productsList.length>1)||(productsList.length===0))?" inregistrari gasite.":" inregistrare gasita.")}</h6>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<div className="card">
							<DataTable
								id="centers_requests_products"
								value={productsList}
								scrollable
								scrollHeight="60vh"
								style={{"minHeight":"63vh"}}
								scrollDirection="both"
								stripedRows
								resizableColumns
								rowGroupMode="rowspan"
								groupRowsBy="product_type"
								sortMode="single"
								sortField="product_type"
								sortOrder={1}
								emptyMessage="Nu exista inregistrari"
							>
								<Column field="product_type" header="Tip produs" style={{"width":"31%","backgroundColor":"#FFFFFF"}} body={tableColTemplate}></Column>
								<Column field="product_name" header="Produs" style={{"width":"45%"}}></Column>
								<Column field="product_mu" header="U.M." style={{"width":"130px"}}></Column>
								<Column field="quantity" header="Cantitate" style={{"width":"80px","textAlign":"center"}}></Column>
								<Column field="buttons" header="" style={{"width":"80px"}} body={tableColTemplate}></Column>
							</DataTable>
						</div>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
				<ConfirmDialog />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
				{dialogValues.openDetails && detailsDialog()}
            </BlockUI>
		);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);		
	}
};

export default ProductsSummaryYearly;


